import { useState, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@/components/ui/Dialog/Dialog';
import ClassificationDeclarations from '@/components/ui/ClassificationDeclarations/ClassificationDeclarations';
import styles from './ClassificationConfirmationPopup.module.scss';

interface ClassificationConfirmationPopupProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedCount: number;
  onSubmit: () => void;
  isSubmitting: boolean;
  classificationNames: string[];
  hasSkippedSupporteds?: boolean;
}

const ClassificationConfirmationPopup = ({
  open,
  setOpen,
  selectedCount,
  onSubmit,
  isSubmitting,
  classificationNames,
  hasSkippedSupporteds = false
}: ClassificationConfirmationPopupProps) => {
  const { t } = useTranslation();
  const [allRequiredFilled, setAllRequiredFilled] = useState(false);

  const canSubmit = allRequiredFilled && !isSubmitting && selectedCount > 0;

  const handleSubmit = () => {
    if (canSubmit) {
      onSubmit();
    }
  };

  return (
    <CustomDialog 
      open={open} 
      setOpen={setOpen}
      onBtnClick={handleSubmit}
      btnText={isSubmitting ? 'submitting' : 'signAndApprove'}
      btnDisabled={!canSubmit}
    >
      <div className={styles.popupContent}>
        <div className={styles.titleSection}>
          <h2 className="heading-h2-bold">
            {classificationNames.length > 1 ? t('requestClassifications') : t('requestClassification')} {classificationNames.join(', ')}
          </h2>
          <p className="body-lr-regular">{selectedCount} {t('supporteds')}</p>
        </div>

        {hasSkippedSupporteds && (
          <div className={styles.infoSection}>
            {t('skippedSupportedsWithExistingClassification')}
          </div>
        )}

        <ClassificationDeclarations
          disabled={isSubmitting}
          onRequiredFilled={setAllRequiredFilled}
          resetTrigger={open}
        />
      </div>
    </CustomDialog>
  );
};

export default ClassificationConfirmationPopup;
